module.exports = __webpack_public_path__ + "static/media/2021gz.7676fdb7.jpg";